import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import CSSTransitionGroup from 'react-addons-css-transition-group';
import Bem from 'bemHelper';
import findIndex from 'lodash/findIndex';
import toNumber from 'lodash/toNumber';
import sensor from 'components/sensor';
import Button from 'components/button';
import { iconTypes } from 'components/icon';

const bemClasses = new Bem('contentSlider');
const cssTransitionConfig = {
  enter: 'enter',
  leave: 'leave',
  classes: {
    up: 'Up',
    right: 'Right',
    bottom: 'Bottom',
    left: 'Left',
    fadeIn: 'FadeIn',
    fadeOut: 'FadeOut'
  }
};

@sensor
export default class Slider extends PureComponent {
  static propTypes = {
    className: PropTypes.string,
    data: PropTypes.arrayOf(PropTypes.shape({})),
    renderContent: PropTypes.func
  };

  static setTransitionClass(dataBlock, action, direction) {
    const start = `${dataBlock}__content_${action}${direction}`;
    const end = `${start}Active`;
    return {
      [action]: start,
      [`${action}Active`]: end
    };
  }

  constructor(props, ctx) {
    super(props, ctx);
    this.changeSlide = this.changeSlide.bind(this);
    this.slide = this.slide.bind(this);

    this.state = {
      desktop: true,
      slideCurrent: props.data ? props.data[0] : null,
      transitionEnter: { enter: null, enterActive: null },
      transitionLeave: { leave: null, leaveActive: null }
    };
    this.index = 0;
  }

  changeSlide(obj, direction) {
    const { enter, leave, classes } = cssTransitionConfig;
    const neededClass = direction >= 0 ? classes.left : classes.right;
    this.index = findIndex(this.props.data, it => obj.id === it.id);
    this.setState({
      slideCurrent: obj,
      transitionEnter: Slider.setTransitionClass('contentSlider', enter, neededClass),
      transitionLeave: Slider.setTransitionClass('contentSlider', leave, neededClass)
    });
  }

  slide(dir, index) {
    const length = this.props.data.length - 1;
    const nextIndex = dir + index;
    if (nextIndex < 0) {
      return this.changeSlide(this.props.data[length], dir);
    }
    if (nextIndex > length) {
      return this.changeSlide(this.props.data[0], dir);
    }
    return this.changeSlide(this.props.data[nextIndex], dir);
  }

  renderControls() {
    return (
      <div {...bemClasses('sliderControls', 'onPhoto')}>
        <Button
          {...bemClasses('btn', 'left')}
          onClick={() => this.slide(-1, this.index)}
          iconType={iconTypes.arrowSliderLeft}
          noPadding
        />
        <Button
          {...bemClasses('btn', 'right')}
          onClick={() => this.slide(1, this.index)}
          iconType={iconTypes.arrowSliderRight}
          noPadding
        />
      </div>
    );
  }

  render() {
    const transitionDuration = toNumber(this.sensor.getVariable('timeDuration'));
    const {
      renderContent,
      data, className
    } = this.props;
    const { desktop, slideCurrent, transitionEnter, transitionLeave } = this.state;
    const { enter, enterActive } = transitionEnter;
    const { leave, leaveActive } = transitionLeave;

    return (
      <div {...bemClasses({ extra: className })}>
        <div {...bemClasses('img')} ref={node => this.node = node}>
          <CSSTransitionGroup
            component="div"
            {...bemClasses('group')}
            transitionName={{
              enter,
              enterActive,
              leave,
              leaveActive
            }}
            transitionEnterTimeout={transitionDuration}
            transitionLeaveTimeout={transitionDuration}
          >
            <div
              {...bemClasses('content')}
              key={slideCurrent.id}
              children={renderContent(slideCurrent, bemClasses)}
            />
          </CSSTransitionGroup>
          {desktop &&
            <div {...bemClasses('sliderControlsContainer')}>
              {data.length > 1 && this.renderControls()}
            </div>
          }
        </div>
      </div>
    );
  }
}
